import { Button, Divider } from "antd";
import React, { useContext } from "react";
import { DashboardContext } from "../../Context/DashboardContext";
import { Outlet, useNavigate } from "react-router-dom";
import DashboardContentHeader from "./DashboardContentHeader";

interface DashboardContentProps {
  onRoundsButtonClick: () => void;
}

const DashboardContent: React.FC<DashboardContentProps> = ({
  onRoundsButtonClick,
}) => {
  const navigate = useNavigate();
  const { jobDescription } = useContext(DashboardContext);

  const handleBackNavigation = () => {
    const currentPath = window.location.pathname;
    const isRequirementPath = currentPath.includes("/requirements");
    if (isRequirementPath) {
      navigate("/");
    } else {
      navigate(`/${jobDescription?._id}/requirements`);
    }
  };

  return (
    <section className="dashboard_content_card">
      <div>
        <DashboardContentHeader
          handleBackNavigation={handleBackNavigation}
          jobPostTitle={jobDescription?.title || null}
          onRoundsButtonClick={onRoundsButtonClick}
        />

        <Divider style={{ margin: "8px 0" }} />
      </div>

      <div
        className="dashboard_content_container"
      >
        <Outlet />
      </div>
      <div className="mobile_only_button_container">
        <Button
          aria-label="Back to requirements"
          onClick={handleBackNavigation}
          className="mobile_back_button"
          type="default"
        >
          Back
        </Button>
      </div>
    </section>
  );
};

export default DashboardContent;
